import { render, staticRenderFns } from "./LegalPageFooter.vue?vue&type=template&id=585e450c"
import script from "./LegalPageFooter.vue?vue&type=script&lang=js"
export * from "./LegalPageFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports